import { WEB_FONT_BOLD, WEB_FONT_DEMI_BOLD, WEB_FONT_MEDIUM } from 'HubStyleTokens/misc';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SLAFeaturePreview = () => /*#__PURE__*/_jsx(_Fragment, {
  children: /*#__PURE__*/_jsxs("svg", {
    "data-test-id": "sla-preview-img",
    width: "100%",
    height: "100%",
    viewBox: "0 0 463 251",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    children: [/*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M217,31.6666667 C217.230119,31.6666667 217.416667,31.8532147 217.416667,32.0833333 L217.416,34.1663333 L218.666667,34.1666667 C218.896785,34.1666667 219.083333,34.3532147 219.083333,34.5833333 C219.083333,34.813452 218.896785,35 218.666667,35 L217,35 L217,35 C216.769881,35 216.583333,34.813452 216.583333,34.5833333 L216.583333,32.0833333 C216.583333,31.8532147 216.769881,31.6666667 217,31.6666667 Z M219.750555,37.4509979 C220.011589,37.3202499 220.327782,37.4265491 220.457772,37.6887538 L220.457772,37.6887538 L220.809096,38.3974149 C220.939086,38.6599739 220.833689,38.9792258 220.573358,39.1106824 C220.497471,39.1485958 220.417018,39.1666667 220.33797,39.1666667 C220.144742,39.1666667 219.958539,39.0589502 219.866141,38.8729266 L219.866141,38.8729266 L219.514817,38.1642654 C219.384826,37.9013521 219.490224,37.5824546 219.750555,37.4509979 Z M213.542228,37.6887538 C213.67257,37.4265491 213.989113,37.3202499 214.249445,37.4509979 C214.509776,37.5824546 214.615174,37.9013521 214.485183,38.1642654 L214.485183,38.1642654 L214.133859,38.8729266 C214.041461,39.0589502 213.855258,39.1666667 213.66203,39.1666667 C213.582982,39.1666667 213.502529,39.1485958 213.426642,39.1106824 C213.166311,38.9792258 213.060914,38.6599739 213.190904,38.3974149 L213.190904,38.3974149 Z M217,30.8440286 C218.838,30.8440286 220.333333,32.3521563 220.333333,34.2058826 C220.333333,36.0596089 218.838,37.5677366 217,37.5677366 C215.162,37.5677366 213.666667,36.0596089 213.666667,34.2058826 C213.666667,32.3521563 215.162,30.8440286 217,30.8440286 Z M219.008628,29.8386303 C219.160752,29.5877643 219.484673,29.5083942 219.733059,29.6607564 C220.771926,30.2974884 221.566271,31.2825275 221.969592,32.4341019 C222.066909,32.7108341 221.922866,33.0144954 221.648481,33.1122907 C221.590512,33.1328419 221.531139,33.1427631 221.472819,33.1427631 C221.2557,33.1427631 221.052635,33.0063458 220.976046,32.7884325 C220.653178,31.867173 220.017632,31.0787874 219.185344,30.5689057 C218.936607,30.4165435 218.85791,30.0894964 219.008628,29.8386303 Z M214.266589,29.6610753 C214.515678,29.5090674 214.839951,29.5880832 214.991021,29.8393036 C215.141739,30.0901696 215.063042,30.4168624 214.814304,30.5692246 C213.982368,31.0791063 213.346822,31.8671375 213.023954,32.7887514 C212.947365,33.0066647 212.7443,33.143082 212.527181,33.143082 C212.468861,33.143082 212.409488,33.1331608 212.351519,33.1126096 C212.077134,33.0148143 211.933091,32.711153 212.030408,32.4344208 C212.433729,31.2824921 213.228074,30.297453 214.266589,29.6610753 Z",
        id: "path-1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M130,94.6666667 C130.230119,94.6666667 130.416667,94.8532147 130.416667,95.0833333 L130.416,97.1663333 L131.666667,97.1666667 C131.896785,97.1666667 132.083333,97.3532147 132.083333,97.5833333 C132.083333,97.813452 131.896785,98 131.666667,98 L130,98 L130,98 C129.769881,98 129.583333,97.813452 129.583333,97.5833333 L129.583333,95.0833333 C129.583333,94.8532147 129.769881,94.6666667 130,94.6666667 Z M132.750555,100.450998 C133.011589,100.32025 133.327782,100.426549 133.457772,100.688754 L133.457772,100.688754 L133.809096,101.397415 C133.939086,101.659974 133.833689,101.979226 133.573358,102.110682 C133.497471,102.148596 133.417018,102.166667 133.33797,102.166667 C133.144742,102.166667 132.958539,102.05895 132.866141,101.872927 L132.866141,101.872927 L132.514817,101.164265 C132.384826,100.901352 132.490224,100.582455 132.750555,100.450998 Z M126.542228,100.688754 C126.67257,100.426549 126.989113,100.32025 127.249445,100.450998 C127.509776,100.582455 127.615174,100.901352 127.485183,101.164265 L127.485183,101.164265 L127.133859,101.872927 C127.041461,102.05895 126.855258,102.166667 126.66203,102.166667 C126.582982,102.166667 126.502529,102.148596 126.426642,102.110682 C126.166311,101.979226 126.060914,101.659974 126.190904,101.397415 L126.190904,101.397415 Z M130,93.8440286 C131.838,93.8440286 133.333333,95.3521563 133.333333,97.2058826 C133.333333,99.0596089 131.838,100.567737 130,100.567737 C128.162,100.567737 126.666667,99.0596089 126.666667,97.2058826 C126.666667,95.3521563 128.162,93.8440286 130,93.8440286 Z M132.008628,92.8386303 C132.160752,92.5877643 132.484673,92.5083942 132.733059,92.6607564 C133.771926,93.2974884 134.566271,94.2825275 134.969592,95.4341019 C135.066909,95.7108341 134.922866,96.0144954 134.648481,96.1122907 C134.590512,96.1328419 134.531139,96.1427631 134.472819,96.1427631 C134.2557,96.1427631 134.052635,96.0063458 133.976046,95.7884325 C133.653178,94.867173 133.017632,94.0787874 132.185344,93.5689057 C131.936607,93.4165435 131.85791,93.0894964 132.008628,92.8386303 Z M127.266589,92.6610753 C127.515678,92.5090674 127.839951,92.5880832 127.991021,92.8393036 C128.141739,93.0901696 128.063042,93.4168624 127.814304,93.5692246 C126.982368,94.0791063 126.346822,94.8671375 126.023954,95.7887514 C125.947365,96.0066647 125.7443,96.143082 125.527181,96.143082 C125.468861,96.143082 125.409488,96.1331608 125.351519,96.1126096 C125.077134,96.0148143 124.933091,95.711153 125.030408,95.4344208 C125.433729,94.2824921 126.228074,93.297453 127.266589,92.6610753 Z",
        id: "path-3"
      }), /*#__PURE__*/_jsx("filter", {
        colorInterpolationFilters: "auto",
        id: "filter-5",
        children: /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceGraphic",
          type: "matrix",
          values: "0 0 0 0 0.317647 0 0 0 0 0.435294 0 0 0 0 0.564706 0 0 0 1.000000 0"
        })
      }), /*#__PURE__*/_jsx("filter", {
        colorInterpolationFilters: "auto",
        id: "filter-6",
        children: /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceGraphic",
          type: "matrix",
          values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
        })
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.21215385,1.42294658 L2.92323077,6.90804885 L0.787846154,4.1774997 C0.607538462,3.94690425 0.315538462,3.94690425 0.135230769,4.1774997 C-0.0450769231,4.40809515 -0.0450769231,4.78153385 0.135230769,5.01212929 L2.59676923,8.16018999 C2.68692308,8.27548772 2.80507692,8.33333333 2.92323077,8.33333333 C3.04107692,8.33333333 3.15923077,8.27548772 3.24938462,8.16018999 L7.86476923,2.25757618 C8.04507692,2.02698073 8.04507692,1.65354203 7.86476923,1.42294658 C7.68446154,1.19235114 7.39246154,1.19235114 7.21215385,1.42294658",
        id: "path-7"
      }), /*#__PURE__*/_jsx("path", {
        d: "M4.74981315,2.5 C6.87583101,2.5 8.23051808,2.75683666 8.24397152,2.7594235 C8.80004721,2.83739837 9.14535227,3.17849224 9.23803155,3.74464154 C9.23826757,3.74545844 9.24496013,3.77356464 9.25606444,3.82559979 L9.28354951,3.96057968 C9.35857942,4.34533191 9.5,5.20241568 9.5,6.19031781 C9.5,7.53067258 9.23952638,8.63118995 9.23691043,8.64190687 C9.14535227,9.20251293 8.80004721,9.5428677 8.23948704,9.62195122 C8.23238661,9.62342942 7.35417568,9.78935698 5.90643562,9.85476718 L5.90643562,9.85476718 L5.04354667,11.3322247 C4.98300618,11.436068 4.87089414,11.5 4.74981315,11.5 C4.62873215,11.5 4.51662012,11.436068 4.45607962,11.3322247 L4.45607962,11.3322247 L3.59356438,9.85476718 C2.14545061,9.78935698 1.26686598,9.62342942 1.25602848,9.62121212 C0.699579088,9.5428677 0.354647732,9.20251293 0.261968451,8.63599409 L0.261968451,8.63599409 L0.253588026,8.59905264 C0.208822379,8.3968446 0,7.3895826 0,6.19031781 C0,4.8495935 0.260847331,3.74981523 0.263089572,3.7383592 C0.354647732,3.17849224 0.699579088,2.83739837 1.26051296,2.75868441 C1.26948192,2.75683666 2.6245427,2.5 4.74981315,2.5 Z M7.06074613,0.5 C9.27116911,0.5 10.6802749,0.773673695 10.6942649,0.776828435 C11.272519,0.860034702 11.6315962,1.22401283 11.7275832,1.82814554 C11.7291377,1.83327199 12,3.00722961 12,4.43750986 C12,5.86818445 11.7291377,7.04253641 11.7264174,7.05397234 C11.6525812,7.51890215 11.4174712,7.83989695 11.0432382,8 C11.1112452,7.5007624 11.1745889,6.84694253 11.1745889,6.13436563 C11.1745889,4.8034597 10.9577436,3.68825911 10.889348,3.37120774 C10.7304058,2.39797045 10.0744294,1.73429202 9.13088031,1.58996267 C8.92141864,1.5513171 7.49599116,1.30130396 5.35318662,1.30130396 C4.1434386,1.30130396 3.16413728,1.38096114 2.5,1.45746359 C2.66399411,1.07692308 2.97954676,0.841106262 3.4318907,0.77603975 C3.44160599,0.773673695 4.85032316,0.5 7.06074613,0.5 Z",
        id: "path-9"
      }), /*#__PURE__*/_jsx("path", {
        d: "M4.74981315,2.5 C6.87583101,2.5 8.23051808,2.75683666 8.24397152,2.7594235 C8.80004721,2.83739837 9.14535227,3.17849224 9.23803155,3.74464154 C9.23826757,3.74545844 9.24496013,3.77356464 9.25606444,3.82559979 L9.28354951,3.96057968 C9.35857942,4.34533191 9.5,5.20241568 9.5,6.19031781 C9.5,7.53067258 9.23952638,8.63118995 9.23691043,8.64190687 C9.14535227,9.20251293 8.80004721,9.5428677 8.23948704,9.62195122 C8.23238661,9.62342942 7.35417568,9.78935698 5.90643562,9.85476718 L5.90643562,9.85476718 L5.04354667,11.3322247 C4.98300618,11.436068 4.87089414,11.5 4.74981315,11.5 C4.62873215,11.5 4.51662012,11.436068 4.45607962,11.3322247 L4.45607962,11.3322247 L3.59356438,9.85476718 C2.14545061,9.78935698 1.26686598,9.62342942 1.25602848,9.62121212 C0.699579088,9.5428677 0.354647732,9.20251293 0.261968451,8.63599409 L0.261968451,8.63599409 L0.253588026,8.59905264 C0.208822379,8.3968446 0,7.3895826 0,6.19031781 C0,4.8495935 0.260847331,3.74981523 0.263089572,3.7383592 C0.354647732,3.17849224 0.699579088,2.83739837 1.26051296,2.75868441 C1.26948192,2.75683666 2.6245427,2.5 4.74981315,2.5 Z M7.06074613,0.5 C9.27116911,0.5 10.6802749,0.773673695 10.6942649,0.776828435 C11.272519,0.860034702 11.6315962,1.22401283 11.7275832,1.82814554 C11.7291377,1.83327199 12,3.00722961 12,4.43750986 C12,5.86818445 11.7291377,7.04253641 11.7264174,7.05397234 C11.6525812,7.51890215 11.4174712,7.83989695 11.0432382,8 C11.1112452,7.5007624 11.1745889,6.84694253 11.1745889,6.13436563 C11.1745889,4.8034597 10.9577436,3.68825911 10.889348,3.37120774 C10.7304058,2.39797045 10.0744294,1.73429202 9.13088031,1.58996267 C8.92141864,1.5513171 7.49599116,1.30130396 5.35318662,1.30130396 C4.1434386,1.30130396 3.16413728,1.38096114 2.5,1.45746359 C2.66399411,1.07692308 2.97954676,0.841106262 3.4318907,0.77603975 C3.44160599,0.773673695 4.85032316,0.5 7.06074613,0.5 Z",
        id: "path-11"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.81478571,4.80557143 L7.38535714,5.22514286 L7.48607143,5.81957143 C7.49935714,5.89285714 7.46935714,5.96657143 7.40978571,6.01028571 C7.34935714,6.054 7.27007143,6.05957143 7.2045,6.02485714 L6.67264286,5.74585714 L6.14078571,6.02485714 C6.10264286,6.045 6.0585,6.05142857 6.01607143,6.04457143 C5.90978571,6.02571429 5.83864286,5.92414286 5.85707143,5.81785714 L5.95821429,5.22685714 L5.52707143,4.80728571 C5.49621429,4.77728571 5.4765,4.73785714 5.47007143,4.695 C5.45507143,4.58828571 5.52921429,4.48928571 5.63592857,4.47428571 L6.23035714,4.38728571 L6.4965,3.84771429 C6.51407143,3.81771429 6.5385,3.79285714 6.56892857,3.77528571 C6.66535714,3.71828571 6.79007143,3.75085714 6.84707143,3.84771429 L7.11278571,4.386 L7.70892857,4.47428571 C7.70807143,4.47385714 7.70721429,4.47257143 7.70592857,4.47257143 L7.70935714,4.47428571 L7.70892857,4.47428571 C7.7505,4.48071429 7.78864286,4.49914286 7.81821429,4.52914286 C7.89364286,4.60628571 7.89235714,4.73014286 7.81478571,4.80557143 L7.81478571,4.80557143 Z M4.84992857,8.22214286 L3.51664286,6.88885714 L3.96107143,6.44442857 L5.29435714,7.77814286 L4.84992857,8.22214286 Z M8.62778571,1.77814286 L7.73892857,0.888857143 L6.85007143,0 L5.96121429,0.888857143 L2.18335714,4.66671429 L3.29421429,5.778 L2.84978571,6.22242857 L1.73892857,5.11114286 L0.627642857,6.22242857 L0.183214286,6.66685714 C-0.0610714286,6.91114286 -0.0610714286,7.31142857 0.183214286,7.55571429 L4.1835,11.5555714 C4.42778571,11.7998571 4.82764286,11.7998571 5.07235714,11.5555714 L5.31664286,11.3112857 L5.51678571,11.1111429 L6.62764286,9.99985714 L5.51678571,8.88857143 L5.96121429,8.44457143 L7.0725,9.55542857 L10.8499286,5.778 L11.7387857,4.88871429 L10.8499286,3.99985714 L9.96107143,3.111 C9.59292857,3.47914286 8.99592857,3.47914286 8.62778571,3.111 C8.25964286,2.74328571 8.25964286,2.14585714 8.62778571,1.77814286 L8.62778571,1.77814286 Z",
        id: "path-13"
      }), /*#__PURE__*/_jsx("path", {
        d: "M1.65108036,5.37405392 C1.46522762,5.19055632 1.44857737,4.87456045 1.61372981,4.66806315 C1.77843224,4.46156584 2.06283643,4.44256609 2.24868917,4.62656369 L5.40188566,7.74052299 C5.74299069,8.07751859 6.25689826,8.07751859 6.59800329,7.74052299 L9.75119978,4.62656369 C9.93660252,4.44306609 10.2210067,4.46156584 10.3861591,4.66806315 C10.5513116,4.87456045 10.5346613,5.19055632 10.3488086,5.37405392 L8.77648541,6.92703362 L10.3636588,8.64201121 C10.5418614,8.8340087 10.5459115,9.15100456 10.3726589,9.34900197 C10.2844576,9.44950066 10.1674559,9.5 10.0500042,9.5 C9.93705252,9.5 9.82365085,9.45300061 9.73634956,9.35850185 L8.10192547,7.59302492 L7.19561211,8.48851322 C6.85495708,8.82500882 6.42745078,8.99300663 5.99994448,8.99300663 C5.57243817,8.99300663 5.14493187,8.82500882 4.80427685,8.48851322 L3.89796349,7.59302492 L2.26353939,9.35850185 C2.1762381,9.45300061 2.06283643,9.5 1.94988476,9.5 C1.83243303,9.5 1.71588131,9.44950066 1.62723001,9.34900197 C1.45442746,9.15100456 1.45802751,8.8340087 1.63623014,8.64201121 L3.22340354,6.92703362 L1.65108036,5.37405392 Z M0,9.44444444 C0,10.3022222 0.672857143,11 1.5,11 L10.5,11 C11.3271429,11 12,10.3022222 12,9.44444444 L12,4.55555556 C12,3.69822222 11.3271429,3 10.5,3 L1.5,3 C0.672857143,3 0,3.69822222 0,4.55555556 L0,9.44444444 Z",
        id: "path-15"
      }), /*#__PURE__*/_jsx("path", {
        d: "M1.65108036,5.37405392 C1.46522762,5.19055632 1.44857737,4.87456045 1.61372981,4.66806315 C1.77843224,4.46156584 2.06283643,4.44256609 2.24868917,4.62656369 L5.40188566,7.74052299 C5.74299069,8.07751859 6.25689826,8.07751859 6.59800329,7.74052299 L9.75119978,4.62656369 C9.93660252,4.44306609 10.2210067,4.46156584 10.3861591,4.66806315 C10.5513116,4.87456045 10.5346613,5.19055632 10.3488086,5.37405392 L8.77648541,6.92703362 L10.3636588,8.64201121 C10.5418614,8.8340087 10.5459115,9.15100456 10.3726589,9.34900197 C10.2844576,9.44950066 10.1674559,9.5 10.0500042,9.5 C9.93705252,9.5 9.82365085,9.45300061 9.73634956,9.35850185 L8.10192547,7.59302492 L7.19561211,8.48851322 C6.85495708,8.82500882 6.42745078,8.99300663 5.99994448,8.99300663 C5.57243817,8.99300663 5.14493187,8.82500882 4.80427685,8.48851322 L3.89796349,7.59302492 L2.26353939,9.35850185 C2.1762381,9.45300061 2.06283643,9.5 1.94988476,9.5 C1.83243303,9.5 1.71588131,9.44950066 1.62723001,9.34900197 C1.45442746,9.15100456 1.45802751,8.8340087 1.63623014,8.64201121 L3.22340354,6.92703362 L1.65108036,5.37405392 Z M0,9.44444444 C0,10.3022222 0.672857143,11 1.5,11 L10.5,11 C11.3271429,11 12,10.3022222 12,9.44444444 L12,4.55555556 C12,3.69822222 11.3271429,3 10.5,3 L1.5,3 C0.672857143,3 0,3.69822222 0,4.55555556 L0,9.44444444 Z",
        id: "path-17"
      })]
    }), /*#__PURE__*/_jsxs("g", {
      id: "SLA-modal-inbox-image-svg",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        stroke: "#DFE3EB",
        fill: "#F5F8FA",
        transform: "translate(308.000000, 152.000000) scale(-1, 1) translate(-308.000000, -152.000000) ",
        x: "155.5",
        y: "55.5",
        width: "305",
        height: "193"
      }), /*#__PURE__*/_jsx("line", {
        x1: "195.5",
        y1: "73.5",
        x2: "460.5",
        y2: "73.5",
        id: "Line",
        stroke: "#DFE3EB",
        strokeLinecap: "square"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        stroke: "#DFE3EB",
        fill: "#FFFFFF",
        transform: "translate(308.000000, 17.000000) scale(-1, 1) translate(-308.000000, -17.000000) ",
        x: "155.5",
        y: "2.5",
        width: "305",
        height: "29"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        stroke: "#DFE3EB",
        fill: "#FFFFFF",
        transform: "translate(308.000000, 43.500000) scale(-1, -1) translate(-308.000000, -43.500000) ",
        x: "155.5",
        y: "31.5",
        width: "305",
        height: "24"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        stroke: "#DFE3EB",
        fill: "#FFFFFF",
        transform: "translate(327.000000, 137.000000) scale(-1, -1) translate(-327.000000, -137.000000) ",
        x: "193.5",
        y: "115.5",
        width: "267",
        height: "43"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#F6F8FA",
        x: "214",
        y: "79",
        width: "239",
        height: "32"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        stroke: "#D4DDE7",
        fill: "#FFFFFF",
        x: "291.5",
        y: "60.5",
        width: "164",
        height: "56",
        rx: "3"
      }), /*#__PURE__*/_jsx("path", {
        d: "M453,60.5 C453.690356,60.5 454.315356,60.779822 454.767767,61.232233 C455.220178,61.6846441 455.5,62.3096441 455.5,63 L455.5,63 L455.5,78.5 L291.5,78.5 L291.5,63 C291.5,62.3096441 291.779822,61.6846441 292.232233,61.232233 C292.684644,60.779822 293.309644,60.5 294,60.5 L294,60.5 Z",
        id: "Rectangle",
        stroke: "#506F90",
        fill: "#506F90"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        stroke: "#DFE3EB",
        fill: "#E5F5F8",
        x: "2.5",
        y: "140.5",
        width: "153",
        height: "55"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        stroke: "#DFE3EB",
        fill: "#FFFFFF",
        x: "2.5",
        y: "195.5",
        width: "153",
        height: "53"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        stroke: "#DFE3EB",
        fill: "#FFFFFF",
        x: "2.5",
        y: "85.5",
        width: "153",
        height: "55"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        stroke: "#DFE3EB",
        fill: "#FFFFFF",
        transform: "translate(79.000000, 58.500000) scale(1, -1) translate(-79.000000, -58.500000) ",
        x: "2.5",
        y: "31.5",
        width: "153",
        height: "54"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        stroke: "#DFE3EB",
        fill: "#FFFFFF",
        x: "2.5",
        y: "2.5",
        width: "153",
        height: "29"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#FFFFFF",
        x: "188",
        y: "6",
        width: "74",
        height: "20"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#E9EDF3",
        x: "195",
        y: "12",
        width: "82",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#E9EDF3",
        x: "195",
        y: "20",
        width: "100",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#E9EDF3",
        x: "201",
        y: "125",
        width: "82",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#E9EDF3",
        x: "201",
        y: "133",
        width: "200",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        stroke: "#DFE3EB",
        fill: "#FFFFFF",
        transform: "translate(327.000000, 209.000000) scale(-1, -1) translate(-327.000000, -209.000000) ",
        x: "193.5",
        y: "187.5",
        width: "267",
        height: "43"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        stroke: "#DFE3EB",
        fill: "#EEF2F6",
        transform: "translate(327.000000, 180.500000) scale(-1, 1) translate(-327.000000, -180.500000) ",
        x: "193.5",
        y: "173.5",
        width: "267",
        height: "14"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#E9EDF3",
        x: "201",
        y: "197",
        width: "82",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#E9EDF3",
        x: "201",
        y: "205",
        width: "200",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#E9EDF3",
        x: "30",
        y: "38",
        width: "54.94",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#E9EDF3",
        x: "30",
        y: "46",
        width: "67",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#E9EDF3",
        x: "30",
        y: "57",
        width: "100",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#E9EDF3",
        x: "30",
        y: "65",
        width: "100",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#E9EDF3",
        x: "30",
        y: "73",
        width: "100",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#E9EDF3",
        x: "30",
        y: "95",
        width: "54.94",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#E9EDF3",
        x: "30",
        y: "103",
        width: "67",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#E9EDF3",
        x: "30",
        y: "114",
        width: "100",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#E9EDF3",
        x: "30",
        y: "122",
        width: "100",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#E9EDF3",
        x: "30",
        y: "130",
        width: "100",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#E9EDF3",
        x: "30",
        y: "205",
        width: "54.94",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#E9EDF3",
        x: "30",
        y: "213",
        width: "67",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#E9EDF3",
        x: "30",
        y: "224",
        width: "100",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#E9EDF3",
        x: "30",
        y: "232",
        width: "100",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#E9EDF3",
        x: "30",
        y: "240",
        width: "100",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#FFFFFF",
        x: "376",
        y: "3",
        width: "76",
        height: "23"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#BDD1D5",
        x: "30",
        y: "149",
        width: "54.94",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#BDD1D5",
        x: "30",
        y: "157",
        width: "67",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#BDD1D5",
        x: "30",
        y: "168",
        width: "100",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#BDD1D5",
        x: "30",
        y: "176",
        width: "100",
        height: "3"
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        fill: "#BDD1D5",
        x: "30",
        y: "184",
        width: "100",
        height: "3"
      }), /*#__PURE__*/_jsxs("g", {
        id: "Group",
        transform: "translate(178.000000, 9.000000)",
        children: [/*#__PURE__*/_jsx("rect", {
          id: "Rectangle",
          stroke: "#FFAC83",
          fill: "#FEF2ED",
          x: "207.5",
          y: "27.5",
          width: "67",
          height: "14"
        }), /*#__PURE__*/_jsx("mask", {
          id: "mask-2",
          fill: "white",
          children: /*#__PURE__*/_jsx("use", {
            xlinkHref: "#path-1"
          })
        }), /*#__PURE__*/_jsx("use", {
          id: "Icons/Utilities/Time",
          fill: "#FF7A59",
          xlinkHref: "#path-1"
        }), /*#__PURE__*/_jsx("mask", {
          id: "mask-4",
          fill: "white",
          children: /*#__PURE__*/_jsx("use", {
            xlinkHref: "#path-3"
          })
        }), /*#__PURE__*/_jsx("use", {
          id: "Icons/Utilities/Time",
          fill: "#FF7A59",
          xlinkHref: "#path-3"
        }), /*#__PURE__*/_jsx("text", {
          id: "Close-in-10m",
          fontFamily: WEB_FONT_DEMI_BOLD,
          fontSize: "7",
          fontWeight: "500",
          fill: "#425B76",
          children: /*#__PURE__*/_jsx("tspan", {
            x: "228",
            y: "37",
            children: 'Close in 10m'
          })
        }), /*#__PURE__*/_jsx("text", {
          id: "First-reply",
          fontFamily: WEB_FONT_DEMI_BOLD,
          fontSize: "7",
          fontWeight: "500",
          fill: "#425B76",
          children: /*#__PURE__*/_jsx("tspan", {
            x: "142",
            y: "81",
            children: 'First reply'
          })
        }), /*#__PURE__*/_jsxs("text", {
          id: "SLA-status:-Warning",
          fontFamily: WEB_FONT_MEDIUM,
          fontSize: "7",
          fontWeight: "400",
          fill: "#FFFFFF",
          children: [/*#__PURE__*/_jsx("tspan", {
            x: "122",
            y: "63",
            children: 'SLA status: '
          }), /*#__PURE__*/_jsx("tspan", {
            x: "158.631",
            y: "63",
            fontFamily: WEB_FONT_BOLD,
            fontWeight: "bold",
            children: 'Due soon'
          })]
        }), /*#__PURE__*/_jsx("text", {
          id: "Completed",
          fontFamily: WEB_FONT_DEMI_BOLD,
          fontSize: "7",
          fontWeight: "500",
          fill: "#425B76",
          children: /*#__PURE__*/_jsx("tspan", {
            x: "232",
            y: "81",
            children: 'Completed'
          })
        }), /*#__PURE__*/_jsxs("text", {
          id: "9m-45s",
          fontFamily: WEB_FONT_BOLD,
          fontSize: "7",
          fontWeight: "bold",
          fill: "#425B76",
          children: [/*#__PURE__*/_jsx("tspan", {
            x: "244.367",
            y: "100",
            children: '9'
          }), /*#__PURE__*/_jsx("tspan", {
            x: "248.889",
            y: "100",
            fontFamily: WEB_FONT_MEDIUM,
            fontWeight: "400",
            children: 'm'
          }), /*#__PURE__*/_jsx("tspan", {
            x: "255.098",
            y: "100",
            fontFamily: WEB_FONT_DEMI_BOLD,
            fontWeight: "500",
            children: ' '
          }), /*#__PURE__*/_jsx("tspan", {
            x: "256.848",
            y: "100",
            children: '45'
          }), /*#__PURE__*/_jsx("tspan", {
            x: "265.892",
            y: "100",
            fontFamily: WEB_FONT_MEDIUM,
            fontWeight: "400",
            children: 's'
          })]
        }), /*#__PURE__*/_jsx("text", {
          id: "Time-to-close",
          fontFamily: WEB_FONT_DEMI_BOLD,
          fontSize: "7",
          fontWeight: "500",
          fill: "#425B76",
          children: /*#__PURE__*/_jsx("tspan", {
            x: "142",
            y: "99",
            children: 'Time to close'
          })
        }), /*#__PURE__*/_jsxs("text", {
          id: "Status:-Waiting-on-u",
          fontFamily: WEB_FONT_DEMI_BOLD,
          fontSize: "9",
          fontWeight: "500",
          children: [/*#__PURE__*/_jsx("tspan", {
            x: "177",
            y: "9",
            fill: "#425B76",
            children: 'Status:  '
          }), /*#__PURE__*/_jsx("tspan", {
            x: "209.418",
            y: "9",
            fill: "#169CB5",
            children: 'Waiting on us'
          })]
        }), /*#__PURE__*/_jsx("text", {
          id: "Reaching-out-in-rega",
          fontFamily: WEB_FONT_DEMI_BOLD,
          fontSize: "9",
          fontWeight: "500",
          fill: "#425B76",
          children: /*#__PURE__*/_jsx("tspan", {
            x: "0",
            y: "37",
            children: 'Reaching out in regards to my last question'
          })
        })]
      }), /*#__PURE__*/_jsxs("g", {
        id: "Group-7",
        transform: "translate(134.500000, 175.000000)",
        children: [/*#__PURE__*/_jsx("circle", {
          id: "Oval",
          stroke: "#FF7A59",
          fill: "#FEF2ED",
          cx: "7",
          cy: "7",
          r: "6.5"
        }), /*#__PURE__*/_jsx("g", {
          id: "Icons/Utilities/Time-2",
          transform: "translate(3.500000, 3.583333)",
          fill: "#FF7A59",
          children: /*#__PURE__*/_jsx("path", {
            d: "M3.5,3.79166667 C3.33891695,3.79166667 3.20833333,3.66108305 3.20833333,3.5 L3.20833333,1.75 C3.20833333,1.58891695 3.33891695,1.45833333 3.5,1.45833333 C3.66108305,1.45833333 3.79166667,1.58891695 3.79166667,1.75 L3.791,3.208 L4.66666667,3.20833333 C4.82774972,3.20833333 4.95833333,3.33891695 4.95833333,3.5 C4.95833333,3.66108305 4.82774972,3.79166667 4.66666667,3.79166667 L3.5,3.79166667 Z M5.42538873,5.50736522 C5.60811265,5.41584163 5.82944714,5.49025105 5.92044021,5.6737943 L5.92044021,5.6737943 L6.16636742,6.16985713 C6.25736049,6.35364841 6.18358232,6.57712471 6.00135026,6.66914437 C5.94822998,6.69568373 5.89191265,6.70833333 5.83657903,6.70833333 C5.70131906,6.70833333 5.57097764,6.63293178 5.50629878,6.50271529 L5.50629878,6.50271529 L5.26037157,6.00665246 C5.1693785,5.82261315 5.24315667,5.59938488 5.42538873,5.50736522 Z M1.07955979,5.6737943 C1.17079879,5.49025105 1.3923792,5.41584163 1.57461127,5.50736522 C1.75684333,5.59938488 1.8306215,5.82261315 1.73962843,6.00665246 L1.73962843,6.00665246 L1.49370122,6.50271529 C1.42902236,6.63293178 1.29868094,6.70833333 1.16342097,6.70833333 C1.10808735,6.70833333 1.05177002,6.69568373 0.998649739,6.66914437 C0.816417675,6.57712471 0.742639512,6.35364841 0.83363258,6.16985713 L0.83363258,6.16985713 Z M3.5,0.88248668 C4.7866,0.88248668 5.83333333,1.93817608 5.83333333,3.23578449 C5.83333333,4.53339291 4.7866,5.58908231 3.5,5.58908231 C2.2134,5.58908231 1.16666667,4.53339291 1.16666667,3.23578449 C1.16666667,1.93817608 2.2134,0.88248668 3.5,0.88248668 Z M4.90603965,0.178707898 C5.01252613,0.00310165557 5.23927102,-0.0524573815 5.41314156,0.0541961271 C6.14034832,0.499908581 6.69638975,1.18943592 6.97871419,1.99553802 C7.04683602,2.18925055 6.94600587,2.40181347 6.75393671,2.47027014 C6.71335872,2.48465597 6.67179703,2.49160085 6.63097311,2.49160085 C6.47899009,2.49160085 6.33684416,2.39610875 6.28323203,2.24356943 C6.05722492,1.59868775 5.6123426,1.04681785 5.02974103,0.689900645 C4.85562457,0.583247136 4.80053687,0.35431414 4.90603965,0.178707898 Z M1.58661252,0.0544193554 C1.76097491,-0.0519861218 1.98796573,0.00332488385 2.09371443,0.179179157 C2.1992172,0.354785399 2.1441295,0.583470364 1.97001304,0.690123873 C1.3876574,1.04704108 0.942775077,1.59866295 0.716767969,2.24379266 C0.663155837,2.39633198 0.521009909,2.49182407 0.369026892,2.49182407 C0.328202975,2.49182407 0.286641276,2.48487919 0.246063286,2.47049337 C0.0539941341,2.4020367 -0.0468360226,2.18947378 0.021285815,1.99576124 C0.303610254,1.18941111 0.859651679,0.499883777 1.58661252,0.0544193554 Z",
            id: "Icons/Utilities/Time"
          })
        })]
      }), /*#__PURE__*/_jsxs("g", {
        id: "Group-7",
        transform: "translate(134.500000, 120.000000)",
        children: [/*#__PURE__*/_jsx("circle", {
          id: "Oval",
          stroke: "#D8DBDF",
          fill: "#F6F8FA",
          cx: "7",
          cy: "7",
          r: "6.5"
        }), /*#__PURE__*/_jsx("g", {
          filter: "url(#filter-5)",
          id: "Icons/Utilities/Time-2",
          children: /*#__PURE__*/_jsx("g", {
            transform: "translate(3.500000, 3.583333)",
            children: /*#__PURE__*/_jsx("path", {
              d: "M3.5,3.79166667 C3.33891695,3.79166667 3.20833333,3.66108305 3.20833333,3.5 L3.20833333,1.75 C3.20833333,1.58891695 3.33891695,1.45833333 3.5,1.45833333 C3.66108305,1.45833333 3.79166667,1.58891695 3.79166667,1.75 L3.791,3.208 L4.66666667,3.20833333 C4.82774972,3.20833333 4.95833333,3.33891695 4.95833333,3.5 C4.95833333,3.66108305 4.82774972,3.79166667 4.66666667,3.79166667 L3.5,3.79166667 Z M5.42538873,5.50736522 C5.60811265,5.41584163 5.82944714,5.49025105 5.92044021,5.6737943 L5.92044021,5.6737943 L6.16636742,6.16985713 C6.25736049,6.35364841 6.18358232,6.57712471 6.00135026,6.66914437 C5.94822998,6.69568373 5.89191265,6.70833333 5.83657903,6.70833333 C5.70131906,6.70833333 5.57097764,6.63293178 5.50629878,6.50271529 L5.50629878,6.50271529 L5.26037157,6.00665246 C5.1693785,5.82261315 5.24315667,5.59938488 5.42538873,5.50736522 Z M1.07955979,5.6737943 C1.17079879,5.49025105 1.3923792,5.41584163 1.57461127,5.50736522 C1.75684333,5.59938488 1.8306215,5.82261315 1.73962843,6.00665246 L1.73962843,6.00665246 L1.49370122,6.50271529 C1.42902236,6.63293178 1.29868094,6.70833333 1.16342097,6.70833333 C1.10808735,6.70833333 1.05177002,6.69568373 0.998649739,6.66914437 C0.816417675,6.57712471 0.742639512,6.35364841 0.83363258,6.16985713 L0.83363258,6.16985713 Z M3.5,0.88248668 C4.7866,0.88248668 5.83333333,1.93817608 5.83333333,3.23578449 C5.83333333,4.53339291 4.7866,5.58908231 3.5,5.58908231 C2.2134,5.58908231 1.16666667,4.53339291 1.16666667,3.23578449 C1.16666667,1.93817608 2.2134,0.88248668 3.5,0.88248668 Z M4.90603965,0.178707898 C5.01252613,0.00310165557 5.23927102,-0.0524573815 5.41314156,0.0541961271 C6.14034832,0.499908581 6.69638975,1.18943592 6.97871419,1.99553802 C7.04683602,2.18925055 6.94600587,2.40181347 6.75393671,2.47027014 C6.71335872,2.48465597 6.67179703,2.49160085 6.63097311,2.49160085 C6.47899009,2.49160085 6.33684416,2.39610875 6.28323203,2.24356943 C6.05722492,1.59868775 5.6123426,1.04681785 5.02974103,0.689900645 C4.85562457,0.583247136 4.80053687,0.35431414 4.90603965,0.178707898 Z M1.58661252,0.0544193554 C1.76097491,-0.0519861218 1.98796573,0.00332488385 2.09371443,0.179179157 C2.1992172,0.354785399 2.1441295,0.583470364 1.97001304,0.690123873 C1.3876574,1.04704108 0.942775077,1.59866295 0.716767969,2.24379266 C0.663155837,2.39633198 0.521009909,2.49182407 0.369026892,2.49182407 C0.328202975,2.49182407 0.286641276,2.48487919 0.246063286,2.47049337 C0.0539941341,2.4020367 -0.0468360226,2.18947378 0.021285815,1.99576124 C0.303610254,1.18941111 0.859651679,0.499883777 1.58661252,0.0544193554 Z",
              id: "Icons/Utilities/Time",
              fill: "#FF7A59"
            })
          })
        })]
      }), /*#__PURE__*/_jsxs("g", {
        id: "Group-7",
        transform: "translate(134.500000, 230.000000)",
        children: [/*#__PURE__*/_jsx("circle", {
          id: "Oval",
          stroke: "#D94C53",
          fill: "#D94C53",
          cx: "7",
          cy: "7",
          r: "6.5"
        }), /*#__PURE__*/_jsx("g", {
          filter: "url(#filter-6)",
          id: "Icons/Utilities/Time-2",
          children: /*#__PURE__*/_jsx("g", {
            transform: "translate(3.500000, 3.583333)",
            children: /*#__PURE__*/_jsx("path", {
              d: "M3.5,3.79166667 C3.33891695,3.79166667 3.20833333,3.66108305 3.20833333,3.5 L3.20833333,1.75 C3.20833333,1.58891695 3.33891695,1.45833333 3.5,1.45833333 C3.66108305,1.45833333 3.79166667,1.58891695 3.79166667,1.75 L3.791,3.208 L4.66666667,3.20833333 C4.82774972,3.20833333 4.95833333,3.33891695 4.95833333,3.5 C4.95833333,3.66108305 4.82774972,3.79166667 4.66666667,3.79166667 L3.5,3.79166667 Z M5.42538873,5.50736522 C5.60811265,5.41584163 5.82944714,5.49025105 5.92044021,5.6737943 L5.92044021,5.6737943 L6.16636742,6.16985713 C6.25736049,6.35364841 6.18358232,6.57712471 6.00135026,6.66914437 C5.94822998,6.69568373 5.89191265,6.70833333 5.83657903,6.70833333 C5.70131906,6.70833333 5.57097764,6.63293178 5.50629878,6.50271529 L5.50629878,6.50271529 L5.26037157,6.00665246 C5.1693785,5.82261315 5.24315667,5.59938488 5.42538873,5.50736522 Z M1.07955979,5.6737943 C1.17079879,5.49025105 1.3923792,5.41584163 1.57461127,5.50736522 C1.75684333,5.59938488 1.8306215,5.82261315 1.73962843,6.00665246 L1.73962843,6.00665246 L1.49370122,6.50271529 C1.42902236,6.63293178 1.29868094,6.70833333 1.16342097,6.70833333 C1.10808735,6.70833333 1.05177002,6.69568373 0.998649739,6.66914437 C0.816417675,6.57712471 0.742639512,6.35364841 0.83363258,6.16985713 L0.83363258,6.16985713 Z M3.5,0.88248668 C4.7866,0.88248668 5.83333333,1.93817608 5.83333333,3.23578449 C5.83333333,4.53339291 4.7866,5.58908231 3.5,5.58908231 C2.2134,5.58908231 1.16666667,4.53339291 1.16666667,3.23578449 C1.16666667,1.93817608 2.2134,0.88248668 3.5,0.88248668 Z M4.90603965,0.178707898 C5.01252613,0.00310165557 5.23927102,-0.0524573815 5.41314156,0.0541961271 C6.14034832,0.499908581 6.69638975,1.18943592 6.97871419,1.99553802 C7.04683602,2.18925055 6.94600587,2.40181347 6.75393671,2.47027014 C6.71335872,2.48465597 6.67179703,2.49160085 6.63097311,2.49160085 C6.47899009,2.49160085 6.33684416,2.39610875 6.28323203,2.24356943 C6.05722492,1.59868775 5.6123426,1.04681785 5.02974103,0.689900645 C4.85562457,0.583247136 4.80053687,0.35431414 4.90603965,0.178707898 Z M1.58661252,0.0544193554 C1.76097491,-0.0519861218 1.98796573,0.00332488385 2.09371443,0.179179157 C2.1992172,0.354785399 2.1441295,0.583470364 1.97001304,0.690123873 C1.3876574,1.04704108 0.942775077,1.59866295 0.716767969,2.24379266 C0.663155837,2.39633198 0.521009909,2.49182407 0.369026892,2.49182407 C0.328202975,2.49182407 0.286641276,2.48487919 0.246063286,2.47049337 C0.0539941341,2.4020367 -0.0468360226,2.18947378 0.021285815,1.99576124 C0.303610254,1.18941111 0.859651679,0.499883777 1.58661252,0.0544193554 Z",
              id: "Icons/Utilities/Time",
              fill: "#FF7A59"
            })
          })
        })]
      }), /*#__PURE__*/_jsx("circle", {
        id: "Oval",
        fill: "#7C98B6",
        cx: "14.5",
        cy: "155.5",
        r: "7.5"
      }), /*#__PURE__*/_jsx("circle", {
        id: "Oval",
        fill: "#7C98B6",
        cx: "14.5",
        cy: "210.5",
        r: "7.5"
      }), /*#__PURE__*/_jsx("circle", {
        id: "Oval",
        fill: "#7C98B6",
        cx: "14.5",
        cy: "100.5",
        r: "7.5"
      }), /*#__PURE__*/_jsx("circle", {
        id: "Oval",
        fill: "#7C98B6",
        cx: "174.5",
        cy: "123.5",
        r: "7.5"
      }), /*#__PURE__*/_jsx("circle", {
        id: "Oval",
        fill: "#7C98B6",
        cx: "14.5",
        cy: "45.5",
        r: "7.5"
      }), /*#__PURE__*/_jsx("line", {
        x1: "298.5",
        y1: "96.5",
        x2: "449.5",
        y2: "96.5",
        id: "Line-4",
        stroke: "#E7EAF0",
        strokeLinecap: "square"
      }), /*#__PURE__*/_jsx("path", {
        d: "M423.949999,55.5263146 L432,64 L432,64 L413,64 L421.050001,55.5263146 C421.810773,54.7255023 423.076687,54.693043 423.877499,55.4538147 C423.902281,55.4773578 423.926456,55.5015324 423.949999,55.5263146 Z",
        id: "Triangle",
        fill: "#506F90"
      }), /*#__PURE__*/_jsxs("g", {
        id: "Icons/General/Check",
        transform: "translate(302.864762, 82.500000)",
        children: [/*#__PURE__*/_jsx("mask", {
          id: "mask-8",
          fill: "white",
          children: /*#__PURE__*/_jsx("use", {
            xlinkHref: "#path-7"
          })
        }), /*#__PURE__*/_jsx("use", {
          id: "Icons/Utilities/Success",
          fill: "#00BDA5",
          xlinkHref: "#path-7"
        })]
      }), /*#__PURE__*/_jsxs("g", {
        id: "Icons/Content/Messages",
        transform: "translate(136.000000, 38.000000)",
        children: [/*#__PURE__*/_jsx("mask", {
          id: "mask-10",
          fill: "white",
          children: /*#__PURE__*/_jsx("use", {
            xlinkHref: "#path-9"
          })
        }), /*#__PURE__*/_jsx("use", {
          fill: "#3F5D75",
          xlinkHref: "#path-9"
        }), /*#__PURE__*/_jsx("g", {
          id: "Group",
          mask: "url(#mask-10)",
          fill: "#7C98B6",
          children: /*#__PURE__*/_jsx("g", {
            id: "Color",
            children: /*#__PURE__*/_jsx("polygon", {
              id: "Rectangle-3-Copy-36",
              points: "0 0 12 0 12 12 0 12"
            })
          })
        })]
      }), /*#__PURE__*/_jsxs("g", {
        id: "Icons/Content/Messages",
        transform: "translate(136.000000, 92.000000)",
        children: [/*#__PURE__*/_jsx("mask", {
          id: "mask-12",
          fill: "white",
          children: /*#__PURE__*/_jsx("use", {
            xlinkHref: "#path-11"
          })
        }), /*#__PURE__*/_jsx("use", {
          fill: "#3F5D75",
          xlinkHref: "#path-11"
        }), /*#__PURE__*/_jsx("g", {
          id: "Group",
          mask: "url(#mask-12)",
          fill: "#7C98B6",
          children: /*#__PURE__*/_jsx("g", {
            id: "Color",
            children: /*#__PURE__*/_jsx("polygon", {
              id: "Rectangle-3-Copy-36",
              points: "0 0 12 0 12 12 0 12"
            })
          })
        })]
      }), /*#__PURE__*/_jsx("rect", {
        id: "Rectangle",
        stroke: "#CBD6E2",
        fill: "#FFFFFF",
        x: "9.5",
        y: "10.5",
        width: "11",
        height: "11",
        rx: "2"
      }), /*#__PURE__*/_jsxs("text", {
        id: "Sort:-Newest",
        fontFamily: WEB_FONT_DEMI_BOLD,
        fontSize: "9",
        fontWeight: "500",
        children: [/*#__PURE__*/_jsx("tspan", {
          x: "30",
          y: "18",
          fill: "#425B76",
          children: 'Sort:  '
        }), /*#__PURE__*/_jsx("tspan", {
          x: "54.084",
          y: "18",
          fill: "#00A4BD",
          children: 'Newest'
        })]
      }), /*#__PURE__*/_jsxs("g", {
        id: "Icons/HubSpotobjects/Ticket",
        transform: "translate(163.000000, 38.000000)",
        children: [/*#__PURE__*/_jsx("mask", {
          id: "mask-14",
          fill: "white",
          children: /*#__PURE__*/_jsx("use", {
            xlinkHref: "#path-13"
          })
        }), /*#__PURE__*/_jsx("use", {
          id: "Mask",
          fill: "#7C98B6",
          xlinkHref: "#path-13"
        })]
      }), /*#__PURE__*/_jsx("image", {
        id: "Screen-Shot-2021-11-30-at-10.20.23-AM",
        x: "162",
        y: "173",
        width: "29",
        height: "24",
        xlinkHref: "data:image/png;base64,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"
      }), /*#__PURE__*/_jsx("image", {
        id: "Screen-Shot-2021-11-30-at-10.20.31-AM",
        x: "161",
        y: "6",
        width: "28",
        height: "24",
        xlinkHref: "data:image/png;base64,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"
      }), /*#__PURE__*/_jsxs("g", {
        id: "Icons/HubSpotobjects/Email/Default",
        transform: "translate(136.000000, 145.000000)",
        children: [/*#__PURE__*/_jsx("mask", {
          id: "mask-16",
          fill: "white",
          children: /*#__PURE__*/_jsx("use", {
            xlinkHref: "#path-15"
          })
        }), /*#__PURE__*/_jsx("use", {
          id: "Icons/Content/Email",
          fill: "#7C98B6",
          xlinkHref: "#path-15"
        })]
      }), /*#__PURE__*/_jsxs("g", {
        id: "Icons/HubSpotobjects/Email/Default",
        transform: "translate(136.000000, 200.000000)",
        children: [/*#__PURE__*/_jsx("mask", {
          id: "mask-18",
          fill: "white",
          children: /*#__PURE__*/_jsx("use", {
            xlinkHref: "#path-17"
          })
        }), /*#__PURE__*/_jsx("use", {
          id: "Icons/Content/Email",
          fill: "#7C98B6",
          xlinkHref: "#path-17"
        })]
      })]
    })]
  })
});
SLAFeaturePreview.displayName = 'SLAFeaturePreview';
export default SLAFeaturePreview;